import { render, staticRenderFns } from "./EditModalStockIncome.vue?vue&type=template&id=5440e730&scoped=true"
import script from "./EditModalStockIncome.vue?vue&type=script&lang=js"
export * from "./EditModalStockIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5440e730",
  null
  
)

export default component.exports